import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Link that uses pure anchor tags but with React Router navigation for normal clicks
 * This preserves ALL native browser behavior while still working with React Router
 */
const Link = React.forwardRef(({ to, onClick, children, ...props }, ref) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    // Check for modified clicks - let browser handle these natively
    const isModifiedClick = e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey;
    
    if (isModifiedClick) {
      // Don't prevent default - let browser handle middle-click, ctrl+click, etc.
      return;
    }

    // For normal left clicks, prevent default and use React Router
    e.preventDefault();
    
    if (onClick) {
      onClick(e);
    }
    
    navigate(to);
  };

  return (
    <a
      href={to}
      onClick={handleClick}
      ref={ref}
      {...props}
    >
      {children}
    </a>
  );
});

Link.displayName = 'Link';

export default Link;